import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.parse-int.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useEffect } from 'react';
import '../assist-chip/assist-chip.js';
import '@mui/material';
import '../button/button.js';
import '../card/card.js';
import '../checkbox/checkbox.js';
import '@mui/material/styles';
import '@mui/system';
import '../../foundation/utils.js';
import '../container/container.js';
import '../dialog/dialog.js';
import '../divider/divider.js';
import '../donut/donut.js';
import '@mui/icons-material/ArrowBack';
import '@mui/material/Drawer';
import '@mui/icons-material/ContentCopyRounded';
import '../fast-copy/fast-copy.types.js';
import '../feedback-banner/feedback-banner.js';
import { FilterChipSelect } from '../filter-chip-select/filter-chip-select.js';
import '../filter-chip/filter-chip.js';
import '../line/line.js';
import '../link/link.js';
import '../logo/logo.js';
import { MenuItem } from '../menu-list/menu-list.js';
import '../modal/modal.js';
import './pagination.types.js';
import '../popover/popover.js';
import '../radio/radio.js';
import '../../foundation/theme/theme.js';
import '../select/select.js';
import '../snackbar/snackbar.js';
import '../snackbar/snackbar.types.js';
import { Stack } from '../stack/stack.js';
import '../stats/stats.js';
import '../stats/stats.types.js';
import '../switch/switch.js';
import '../table/table.js';
import '../table/table.types.js';
import '../tabs/tabs.js';
import '../tag/tag.js';
import '../tag/tag.types.js';
import '../text-field/text-field.js';
import { Text } from '../text/text.js';
import '../tooltip/tooltip.js';

const sizesAvailable = ['25', '50', '100', '200'];
const SelectPageSize = ({
  pageSize,
  onChangePageSize,
  onChangePage
}) => {
  useEffect(() => {
    onChangePage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize]);
  return jsx(Stack, {
    children: jsx(FilterChipSelect, Object.assign({
      "data-testid": "select-page-size",
      variant: "selected",
      style: {
        minWidth: 150
      },
      value: pageSize,
      onChange: event => {
        onChangePageSize(parseInt(String(event.target.value), 10));
      },
      renderValue: value => jsxs(Text, Object.assign({
        variant: "body2"
      }, {
        children: [value, " por p\u00E1gina"]
      })),
      size: "small"
    }, {
      children: sizesAvailable.map(value => jsx(MenuItem, Object.assign({
        value: value
      }, {
        children: jsxs(Text, Object.assign({
          variant: "body2"
        }, {
          children: [value, " por p\u00E1gina"]
        }))
      }), value))
    }))
  });
};

export { SelectPageSize };
